
import React, { useState, useEffect } from "react";
import { mixGetV1 } from "services/mixin"; // hoặc mixGetV2 nếu bạn có
import dayjs from 'dayjs';
const PayoutContent = () => {
    // const [selectMonth, setSelectMonth] = useState(false);
    // const [selectRate, setSelectRate] = useState(false);
    const [selectTime, setSelectTime] = useState(false);

    // const [timeSelectedLabel2, setTimeSelectedLabel2] = useState('Tuần trước');
    // const [typeSelectedLabel, setTypeSelectedLabel] = useState('Số lượng người dùng');
    const [timeSelectedLabel, setTimeSelectedLabel] = useState('Tuần trước');
    

    const [selectMonth, setSelectMonth] = useState(false);
    const [timeSelectedLabel2, setTimeSelectedLabel2] = useState("Last week");
    const [timeSelectedCheck2, setTimeSelectedCheck2] = useState(1);
    const [timeSelectedCheck2Value, setTimeSelectedCheck2Value] = useState("");

    const [selectRate, setSelectRate] = useState(false);
    const [typeSelected, setTypeSelected] = useState(1);
    const [typeSelectedLabel, setTypeSelectedLabel] = useState("Number of users");

    const [topThree, setTopThree] = useState([]);
    const [restUsers, setRestUsers] = useState([]);
    const [dataDashboard, setDataDashboard] = useState({});
    const [performanceItems, setPerformanceItems] = useState([]);
    const [performancePagination, setPerformancePagination] = useState({ total: 0, currentPage: 1, limit: 10 });

    const [dates, setDates] = useState({ today: "", oneWeekAgo: "", oneMonthAgo: "", sixMonthsAgo: "" });

    const calculateDates = () => {
        const currentDate = new Date();
        const today = dayjs(currentDate).format("YYYY-MM-DD");
        const oneWeekAgo = dayjs(currentDate).subtract(7, "day").format("YYYY-MM-DD");
        const oneMonthAgo = dayjs(currentDate).subtract(1, "month").format("YYYY-MM-DD");
        const sixMonthsAgo = dayjs(currentDate).subtract(6, "month").format("YYYY-MM-DD");

        setDates({ today, oneWeekAgo, oneMonthAgo, sixMonthsAgo });

        // Cập nhật value theo default
        setTimeSelectedCheck2(oneWeekAgo);
        setTimeSelectedCheck2Value(oneWeekAgo);
    };

    useEffect(() => {
        calculateDates();
    }, []);

  // Khi dropdown tháng thay đổi
    const timeSelectedChange = (value, label) => {
        setTimeSelectedCheck2(value);
        setTimeSelectedLabel2(label);

        if (value === 1) setTimeSelectedCheck2Value(dates.oneWeekAgo);
        else if (value === 2) setTimeSelectedCheck2Value(dates.oneMonthAgo);
        else setTimeSelectedCheck2Value(dates.sixMonthsAgo);

        setSelectMonth(false);
    };

  // Khi dropdown type thay đổi
    const onTimeFilterChangeType = (value, label) => {
        setTypeSelected(value);
        setTypeSelectedLabel(label);
        setSelectRate(false);
    };

  // Lấy danh sách affiliate
    const getListData = async () => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const userId = user?.id;
        if (!userId) {
            console.warn("User chưa đăng nhập hoặc data chưa có id");
            return;
        }
        const res = await mixGetV1(
        `/api/v1/fe/customer/list_aff/${userId}?between[]=created_at,${timeSelectedCheck2Value} 00:00:00,${dates.today} 23:59:59&type=${typeSelected}`
        );

        if (res.status) {
        const items = res.data.items ?? [];

            setTopThree(items.slice(0, 3));
            setRestUsers(items.length > 3 ? items.slice(3, 9) : []);
        }

        getDataDash();
    };

  // Lấy dashboard
    const getDataDash = async () => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const userId = user?.id; // Thay vì user?.info?.id
        if (!userId) {
            console.warn("User chưa đăng nhập hoặc data chưa có id");
        return;
        }
        const res = await mixGetV1(
            `/api/v1/fe/customer/dashboard_aff/${userId}?between[]=created_at,${timeSelectedCheck2Value} 00:00:00,${dates.today} 23:59:59&type=${typeSelected}`
        );
        if (res.status) setDataDashboard(res.data);
    };

    // Khi time/type thay đổi, gọi lại API
    useEffect(() => {
        getListData();
    }, [timeSelectedCheck2Value, typeSelected, dates.today]);

    // const topThree = [
    //     { username: 'Nguyen Van A', avatar: '/logo192.png', count_affiliate: 120 },
    //     { username: 'Tran Thi B', avatar: '/logo192.png', count_affiliate: 90 },
    //     { username: 'Le Van C', avatar: '/logo192.png', count_affiliate: 70 },
    // ];

    // const restUsers = [
    //     { username: 'Pham Van D', avatar: '/logo192.png', total_affiliate_commission: 50 },
    //     { username: 'Ho Thi E', avatar: '/logo192.png', total_affiliate_commission: 40 },
    //     { username: 'Ngo Van F', avatar: '/logo192.png', total_affiliate_commission: 35 },
    // ];

    // const dataDashboard = {
    //     total_affiliate_commission: 5000000,
    //     total_orders: 120,
    //     total_link: 300,
    //     total_code: 200,
    // };

    // const performanceItems = [
    //     { id: 1, day: '2025-10-28', links: 12, code: 5, customer: 3, earning: '1,000,000 VND' },
    //     { id: 2, day: '2025-10-27', links: 8, code: 3, customer: 2, earning: '750,000 VND' },
    //     { id: 3, day: '2025-10-26', links: 10, code: 4, customer: 1, earning: '500,000 VND' },
    // ];

    // const dataDashboardCount = {
    //     total_link: 12345,
    //     total_code: 678,
    // };

    const totalLink = dataDashboard.total_link ?? 0;
    const totalCode = dataDashboard.total_code ?? 0;
    const conversionRate = totalCode > 0 ? totalLink / totalCode : 0;

    const handleMonthSelect = (value) => {
        let dateValue = "";
        let label = "";

        if (value === 1) {
            dateValue = dates.oneWeekAgo;
            label = "Tuần trước";
        } else if (value === 2) {
            dateValue = dates.oneMonthAgo;
            label = "Tháng trước";
        } else if (value === 3) {
            dateValue = dates.sixMonthsAgo;
            label = "6 tháng trước";
        }

        setTimeSelectedCheck2Value(dateValue);
        setTimeSelectedLabel2(label);
        setSelectMonth(false);

        getListData(); // gọi API ngay khi chọn
    };

    const handleTypeSelect = (value) => {
        let label = "";
        if (value === 1) label = "Số lượng người dùng";
        else if (value === 2) label = "Tỷ lệ chuyển đổi";
        else if (value === 3) label = "Hoa hồng";

        setTypeSelected(value);
        setTypeSelectedLabel(label);
        setSelectRate(false);

        getListData(); // gọi API ngay khi chọn
    };


    const [selectTime1, setSelectTime1] = useState(false);
    const [timeSelectedLabel1, setTimeSelectedLabel1] = useState("Tuần trước");

    // Dữ liệu tĩnh để xuất
    const performanceItems1 = [
        { name: "Người dùng 1", clicks: 120, conversions: 30 },
        { name: "Người dùng 2", clicks: 80, conversions: 10 },
    ];

    const json_fields = {
        name: "Tên người dùng",
        clicks: "Lượt nhấp",
        conversions: "Chuyển đổi",
    };

    const onTimeFilterChange = (id: number, label: string) => {
        setTimeSelectedLabel(label);
        setSelectTime(false);
    };

    const startDownload = () => {
        console.log("Start download");
    };

    const finishDownload = () => {
        console.log("Finish download");
    };

    return (
        <div className="payout-content">
            <div className="group">
                <div className="leaderboard">
                    <div className="leaderboard__filters">
                        {/* Dropdown Month */}
                        <div className="dropdown-wrapper">
                            <button className="time-btn min-w-140px" onClick={() => setSelectMonth(!selectMonth)}>
                                {timeSelectedLabel2}
                                <div className="icon">
                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                                        <path d="M19.2734 9L12.2734 16L5.27344 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </button>
                            {selectMonth && (
                                <div className="dropdown dropdown-140px">
                                    <button onClick={() => handleMonthSelect(1)}>Tuần trước</button>
                                    <button onClick={() => handleMonthSelect(2)}>Tháng trước</button>
                                    <button onClick={() => handleMonthSelect(3)}>6 tháng trước</button>
                                </div>
                            )}
                        </div>

                        {/* Dropdown Rate */}
                        <div className="dropdown-wrapper">
                            <button className="time-btn" onClick={() => setSelectRate(!selectRate)}>
                                {typeSelectedLabel}
                                <div className="icon">
                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                                        <path d="M19.2734 9L12.2734 16L5.27344 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </button>
                            {selectRate && (
                                <div className="dropdown">
                                    <button onClick={() => handleTypeSelect(1)}>Số lượng người dùng</button>
                                    <button onClick={() => handleTypeSelect(2)}>Tỷ lệ chuyển đổi</button>
                                    <button onClick={() => handleTypeSelect(3)}>Hoa hồng</button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Top Three */}
                    <div className="user-show-rank">
                        <div className="mw-318">
                            <div className="list-rank">
                                {topThree[1] && (
                                    <div className="one-rank top2">
                                        <div className="img-box">
                                            <img src={topThree[1].avatar || '/logo192.png'} alt="User 2" />
                                        </div>
                                        <div className="number">2</div>
                                        <div className="name">{topThree[1].username}</div>
                                        <div className="count">{topThree[1].count_affiliate} người dùng</div>
                                    </div>
                                )}
                                {topThree[0] && (
                                    <div className="one-rank top1">
                                        <div className="icon-crown">
                                            <svg
                                                width="32"
                                                height="27"
                                                viewBox="0 0 32 27"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M30.3547 2.86876C29.8675 2.66581 29.3309 2.61246 28.8132 2.71552C28.2956 2.81857 27.8203 3.07336 27.448 3.44743L24 6.89543L17.8853 0.780764C17.3853 0.280841 16.7071 0 16 0C15.2929 0 14.6147 0.280841 14.1147 0.780764L8 6.89543L4.552 3.44743C4.17906 3.07461 3.70396 2.82072 3.18675 2.71788C2.66954 2.61503 2.13345 2.66784 1.64625 2.86962C1.15906 3.07141 0.74262 3.41312 0.449596 3.85154C0.156571 4.28997 0.000112598 4.80543 0 5.33276L0 19.4474C0.00211714 21.2149 0.705176 22.9094 1.95496 24.1591C3.20474 25.4089 4.89921 26.112 6.66667 26.1141H25.3333C27.1008 26.112 28.7953 25.4089 30.045 24.1591C31.2948 22.9094 31.9979 21.2149 32 19.4474V5.33276C32.0001 4.80539 31.8439 4.28981 31.551 3.85123C31.2582 3.41265 30.8418 3.07075 30.3547 2.86876Z"
                                                    fill="#FF2079"
                                                />
                                            </svg>
                                        </div>
                                        <div className="img-box">
                                            <img src={topThree[0].avatar || '/logo512.png'} alt="User 1" />
                                        </div>
                                        <div className="number">1</div>
                                        <div className="name">{topThree[0].username}</div>
                                        <div className="count">{topThree[0].count_affiliate} người dùng</div>
                                    </div>
                                )}
                                {topThree[2] && (
                                    <div className="one-rank top3">
                                        <div className="img-box">
                                            <img src={topThree[2].avatar || '/logo192.png'} alt="User 3" />
                                        </div>
                                        <div className="number">3</div>
                                        <div className="name">{topThree[2].username}</div>
                                        <div className="count">{topThree[2].count_affiliate} người dùng</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Rest Users */}
                    <div className="leaderboard__list">
                        {restUsers.map((user, i) => (
                            <div key={i} className="user-row">
                                <div className="rank">#{i + 4}</div>
                                <img src={user.avatar || '/images/image-theme/kh1.png'} className="user-avatar" alt="" />
                                <div className="user-name">{user.username}</div>
                                <div className="user-count">{user.total_affiliate_commission} người dùng</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Dashboard Groups */}
            <div className="group">
                <div className="group-cols">
                    <div className="group-col">
                        <label className="group-label mb-8 d-flex gap-8 align-items-center">
                            <div className="icon">{/* SVG icon */}</div>
                            Tổng hoa hồng
                        </label>
                        <div className="fz-32-600"> {(dataDashboard?.total_affiliate_commission ?? 0).toLocaleString()}</div>
                    </div>
                    <div className="separator" />
                    <div className="group-col">
                        <label className="group-label mb-16 d-flex gap-8 align-items-center">
                            <div className="icon">{/* SVG icon */}</div>
                            Tổng đơn hàng
                        </label>
                        <div className="input-row">
                            <input className="input" type="text" value={dataDashboard.total_orders} disabled />
                        </div>
                    </div>
                </div>
            </div>

            <div className="group">
                <div className="group-cols">
                    {/* Tổng số lần nhấp */}
                    <div className="group-col">
                        <label className="group-label mb-16 d-flex gap-8 align-items-center">
                            <div className="icon">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_692_5546)">
                                        <path d="M3 12H6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 3V6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7.79961 7.79961L5.59961 5.59961" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M16.1992 7.79961L18.3992 5.59961" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7.79961 16.2002L5.59961 18.4002" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 12L21 15L17 17L15 21L12 12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_692_5546">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            Tổng số lần nhấp
                        </label>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                placeholder="Your referral code"
                                value={totalLink > 0 ? totalLink.toLocaleString() : 0}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="separator" />

                    {/* Tổng mã */}
                    <div className="group-col">
                        <label className="group-label mb-16 d-flex gap-8 align-items-center">
                            <div className="icon">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_692_5538)">
                                        <path d="M8 9H16" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8 13H14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M11.012 19.193L8 21V18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 21L22 19L20 17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M17 17L15 19L17 21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_692_5538">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            Tổng mã
                        </label>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                placeholder="Your referral link"
                                value={totalCode > 0 ? totalCode.toLocaleString() : 0}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="separator" />

                    {/* Tỷ lệ chuyển đổi */}
                    <div className="group-col">
                        <label className="group-label mb-16 d-flex gap-8 align-items-center">
                            <div className="icon">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M14 16H19V21M10 8H5V3M19.4176 9.0034C18.8569 7.61566 17.9181 6.41304 16.708 5.53223C15.4979 4.65141 14.0652 4.12752 12.5723 4.02051C11.0794 3.9135 9.58606 4.2274 8.2627 4.92661C6.93933 5.62582 5.83882 6.68254 5.08594 7.97612M4.58203 14.9971C5.14272 16.3848 6.08146 17.5874 7.29157 18.4682C8.50169 19.3491 9.93588 19.8723 11.4288 19.9793C12.9217 20.0863 14.4138 19.7725 15.7371 19.0732C17.0605 18.374 18.1603 17.3175 18.9131 16.0239" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            Tỷ lệ chuyển đổi
                        </label>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                placeholder="Your referral link"
                                value={conversionRate > 0 ? conversionRate.toLocaleString() : 0}
                                disabled
                            />
                        </div>
                    </div>

                </div>
            </div>

            {/* Performance Table */}
            <div className="group">
                <div className="search-export">
                    <div className="title-table">
                        <div className="title-13-600">Chi tiết hiệu suất</div>
                        <div className="dropdown-time">
                            <label htmlFor="">Xem kết quả của</label>
                            <div className="dropdown-wrapper">
                                <button
                                    className="time-btn"
                                    onClick={() => setSelectTime(!selectTime)}
                                >
                                    {timeSelectedLabel}
                                    <div className="icon">
                                        <svg
                                            width="25"
                                            height="24"
                                            viewBox="0 0 25 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M19.2734 9L12.2734 16L5.27344 9"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </button>
                                {selectTime && (
                                    <div className="dropdown">
                                        <button onClick={() => onTimeFilterChange(1, "Tuần trước")}>
                                            Tuần trước
                                        </button>
                                        <button onClick={() => onTimeFilterChange(2, "Tháng trước")}>
                                            Tháng trước
                                        </button>
                                        <button onClick={() => onTimeFilterChange(3, "6 tháng trước")}>
                                            6 tháng trước
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {performanceItems && performanceItems.length > 0 && (
                        <button
                            className="export-btn"
                            onClick={() => {
                                startDownload();
                                console.log("Export data:", performanceItems);
                                finishDownload();
                            }}
                        >
                            Xuất
                            <i className="icon-download">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </i>
                        </button>
                    )}
                </div>

                <div className="table-wrapper">
                    <table className="referrals-table one-column-20">
                        <thead>
                            <tr>
                                <th className="text-left">Ngày</th>
                                <th className="text-center">Liên kết</th>
                                <th className="text-center">Mã</th>
                                <th className="text-center">Khách hàng</th>
                                <th className="text-right">Doanh thu</th>
                            </tr>
                        </thead>
                        <tbody>
                            {performanceItems.map(item => (
                                <tr key={item.id}>
                                    <td className="text-left">{item.day}</td>
                                    <td className="text-center">{item.links}</td>
                                    <td className="text-center">{item.code}</td>
                                    <td className="text-center">{item.customer}</td>
                                    <td className="text-right">{item.earning}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PayoutContent
